import Sale from '@common/Sale';
import dev from './saleData.dev.json';

/**
 * Dev-only sales (will only show in non-prod sales).
 */
export const devSales: Sale[] = dev;

// const nowTime = Date.now();
// const getDaysFromNow = (days: number) => new Date(nowTime + daysToMs(days)).toISOString();

// @TODO: We need better tools to allow us to test the various states of the UI from here as mock data, clean this shit up

/**
 * Partial sale objects that extend existing sales. Note that it will not add a sale from this list; if the sale ID
 * does not exist in the base sales, it will not be added.
 */
export const devSaleOverrides: Partial<Sale>[] = [
  {
    saleId: 'BAYC',
    tokenContractAddress: '0x8c2220db0CCB009Da045744e40e1aCF54A51a478',
    mbaasAddressLabel: 'ethsale_character_pass_bored_ape_yacht_club',
    tokenproofPolicyId: '17c98382-7cd3-437c-8e83-1ea8d2e663d2',
  },
  {
    saleId: 'MAYC',
    tokenContractAddress: '0x63929D23F2B1451b2783158929f95fEEd88Be251', // FMAYC contract address
    mbaasAddressLabel: 'ethsale_character_pass_mutant_ape_yacht_club',
    tokenproofPolicyId: '4d8e8ccc-86d1-4f7d-b01f-32146dc3e2ca',
  },
];
